import axios from "axios";
import deepParseJson from "../lib/deepParseJson";
import config from './index'

const P2PService = axios.create({
    timeout: 60000,
    baseURL: config.P2PAPI_URL
});

P2PService.interceptors.request.use(
    async (config) => {
        const rawPersistData = await localStorage.getItem("user_token");
        const persistData = deepParseJson(rawPersistData);
        if (persistData) {
            config.headers["Authorization"] = `${persistData}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default P2PService;